// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Key service site (Schluesseldienst): mobile-first layer.
   Loaded by components/Header.jsx right after assets/css/main.css (the
   BootstrapMade template) and overrides it. Phones are the base case; wider
   screens add columns. Every selector is scoped to .KeysHome so
   nothing leaks into the panel app. Logical properties keep RTL working.
   ========================================================================== */

.KeysHome {
  --site-header-h: 64px;
  --site-gutter: 16px;
  /* Accent text on light backgrounds: #feb900 is too light for text on white. */
  --accent-text: #8a6300;
  --accent-ink: #1f2328;
  font-size: 1rem;
  line-height: 1.6;
  overflow-wrap: break-word;
  overflow-x: clip;
}

@media (min-width: 1200px) {
  .KeysHome {
    --site-header-h: 80px;
  }
}

.KeysHome img {
  max-width: 100%;
  height: auto;
}

/* Anchors land below the fixed header. */
.KeysHome [id],
.KeysHome section,
.KeysHome .section {
  scroll-margin-top: calc(var(--site-header-h) + 12px);
}

/* Keyboard focus in the site's accent (the panel's global ring is teal). */
.KeysHome :focus-visible {
  outline-color: var(--accent-color) !important;
  box-shadow: 0 0 0 4px rgba(31, 35, 40, 0.55);
}

/* ------------------------------------------------------------------ Header */
.KeysHome .site-header {
  --nav-text: #ffffff;
  z-index: 997;
  color: var(--nav-text);
  background-color: rgba(0, 0, 0, 0.35);
  transition:
    background-color 0.3s,
    box-shadow 0.3s;
}

.KeysHome .site-header.sticked,
.KeysHome .site-header.is-open {
  --nav-text: #1f2328;
  background-color: #ffffff;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);
}

.KeysHome .site-header__bar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: var(--site-header-h);
  padding-inline: var(--site-gutter);
}

.KeysHome .site-header__logo {
  display: inline-flex;
  align-items: baseline;
  min-width: 0;
  min-height: 44px;
  align-self: center;
  padding-block: 8px;
  margin-inline-end: auto;
  color: var(--nav-text);
  font-family: var(--heading-font);
  font-weight: 700;
  font-size: clamp(1.25rem, 1rem + 1.2vw, 1.75rem);
  line-height: 1.2;
}

.KeysHome .site-header__logo .sitename {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.KeysHome .site-header__dot {
  color: var(--accent-color);
}

.KeysHome .site-header__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--nav-text);
  font-size: 24px;
  cursor: pointer;
}

.KeysHome .site-nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.KeysHome .site-nav__link,
.KeysHome .site-nav__sublink {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 10px 12px;
  border: 0;
  background: none;
  color: #1f2328;
  font-family: var(--nav-font);
  font-size: 1.0625rem;
  font-weight: 500;
  text-align: start;
  cursor: pointer;
}

.KeysHome .site-nav__link.active,
.KeysHome .site-nav__sublink.active {
  color: var(--accent-text);
  box-shadow: inset 3px 0 0 var(--accent-color);
}

[dir="rtl"] .KeysHome .site-nav__link.active,
[dir="rtl"] .KeysHome .site-nav__sublink.active {
  box-shadow: inset -3px 0 0 var(--accent-color);
}

.KeysHome .site-nav__chevron {
  flex: none;
  font-size: 0.75em;
  transition: transform 0.2s;
}

.KeysHome .site-nav__item--has-sub.is-open .site-nav__chevron {
  transform: rotate(180deg);
}

.KeysHome .site-nav__sub {
  display: none;
}

.KeysHome .site-nav__item--has-sub.is-open > .site-nav__sub {
  display: block;
}

.KeysHome .site-nav__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.KeysHome .site-header__login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 24px;
  border-radius: 8px;
  background: var(--accent-color);
  color: var(--accent-ink);
  font-weight: 600;
  white-space: nowrap;
}

.KeysHome .site-header__login:hover {
  background: #ffc933;
  color: var(--accent-ink);
}

/* Phones and tablets: full-width panel below the bar. */
@media (max-width: 1199.98px) {
  .KeysHome .site-nav {
    display: none;
    position: fixed;
    inset: var(--site-header-h) 0 0 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 8px var(--site-gutter) calc(24px + env(safe-area-inset-bottom));
    background: #ffffff;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }

  .KeysHome .site-header.is-open .site-nav {
    display: block;
  }

  .KeysHome .site-nav__list > li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .KeysHome .site-nav__sub {
    padding-block-end: 8px;
    padding-inline-start: 12px;
  }

  .KeysHome .site-nav__sublink {
    font-size: 1rem;
    font-weight: 400;
    min-height: 44px;
  }

  .KeysHome .site-nav__actions {
    padding-block-start: 20px;
  }

  .KeysHome .site-header__login {
    flex: 1 1 160px;
  }
}

/* Desktop: inline menu, hover/focus dropdown. */
@media (min-width: 1200px) {
  .KeysHome .site-header__toggle {
    display: none;
  }

  .KeysHome .site-nav {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .KeysHome .site-nav__list {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .KeysHome .site-nav__list > li {
    position: relative;
  }

  .KeysHome .site-nav__link {
    width: auto;
    min-height: 44px;
    padding: 8px 12px;
    color: var(--nav-text);
    font-size: 14px;
    text-transform: uppercase;
    white-space: nowrap;
    opacity: 0.85;
  }

  .KeysHome .site-nav__link:hover,
  .KeysHome .site-nav__link.active {
    color: var(--nav-text);
    opacity: 1;
    box-shadow: inset 0 -2px 0 var(--accent-color);
  }

  [dir="rtl"] .KeysHome .site-nav__link.active {
    box-shadow: inset 0 -2px 0 var(--accent-color);
  }

  .KeysHome .site-nav__sub {
    position: absolute;
    inset-block-start: 100%;
    inset-inline-start: 0;
    z-index: 99;
    min-width: 280px;
    padding: 8px 0;
    border-radius: 6px;
    background: #ffffff;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
  }

  .KeysHome .site-nav__item--has-sub:hover > .site-nav__sub,
  .KeysHome .site-nav__item--has-sub:focus-within > .site-nav__sub {
    display: block;
  }

  .KeysHome .site-nav__sublink {
    min-height: 44px;
    padding: 8px 20px;
    font-size: 15px;
    font-weight: 400;
  }

  .KeysHome .site-nav__sublink:hover {
    color: var(--accent-text);
  }
}

/* -------------------------------------------------------------------- Hero */
.KeysHome .hero {
  isolation: isolate;
  min-height: 100vh;
  min-height: 100svh;
  background-color: #1f2328;
}

.KeysHome .hero--compact {
  min-height: clamp(320px, 55svh, 520px);
}

.KeysHome .hero__media {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: cover;
}

.KeysHome .hero::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.6);
}

.KeysHome .hero .info {
  width: 100%;
  padding: calc(var(--site-header-h) + 32px) 0 48px;
}

.KeysHome .hero .info .hero__title {
  position: relative;
  margin-bottom: 24px;
  padding-bottom: 24px;
  color: #ffffff !important;
  font-size: clamp(1.75rem, 1.1rem + 3.4vw, 3.5rem);
  font-weight: 700;
  line-height: 1.15;
  overflow-wrap: anywhere;
  hyphens: auto;
}

.KeysHome .hero--compact .info .hero__title {
  font-size: clamp(1.5rem, 1.1rem + 2.2vw, 2.75rem);
}

.KeysHome .hero .info .hero__title::after {
  content: "";
  position: absolute;
  inset-inline: 0;
  bottom: 0;
  width: 80px;
  height: 4px;
  margin: auto;
  background: var(--accent-color);
}

.KeysHome .hero .info p {
  color: #e6e3e3;
  font-size: clamp(1rem, 0.95rem + 0.4vw, 1.125rem);
}

.KeysHome .hero .info .btn-get-started {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 10px 32px;
  margin: 8px 0 0;
  color: #ffffff;
}

.KeysHome .hero .info .btn-get-started:hover {
  color: var(--accent-ink);
}

/* ---------------------------------------------------------------- Sections */
.KeysHome section,
.KeysHome .section {
  padding-block: clamp(40px, 6vw, 60px);
}

.KeysHome .section-title {
  padding-bottom: clamp(32px, 5vw, 60px);
}

.KeysHome .section-title h2 {
  font-size: clamp(1.5rem, 1.15rem + 1.6vw, 2rem);
}

.KeysHome .section-title h2::before,
.KeysHome .section-title h2::after {
  width: clamp(20px, 6vw, 50px);
}

.KeysHome .section-title h2::before {
  margin: 0;
  margin-inline-end: 12px;
  margin-block-end: 10px;
}

.KeysHome .section-title h2::after {
  margin: 0;
  margin-inline-start: 12px;
  margin-block-end: 10px;
}

/* Services cards */
.KeysHome .services .service-item {
  padding: clamp(24px, 4vw, 40px);
}

.KeysHome .services .service-item .icon {
  width: 72px;
  height: 72px;
  margin-bottom: 24px;
}

.KeysHome .services .service-item .icon svg {
  font-size: 40px;
}

.KeysHome .services .service-item h3 {
  font-size: clamp(1.125rem, 1rem + 0.6vw, 1.375rem);
}

.KeysHome .services .service-item p {
  font-size: 0.9375rem;
  line-height: 1.6;
}

.KeysHome .services .service-item .readmore {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  margin-top: 8px;
}

/* Alt services (home + Leistungen pages) */
.KeysHome .alt-services .features-image {
  min-height: 0;
  aspect-ratio: 4 / 3;
}

@media (min-width: 992px) {
  .KeysHome .alt-services .features-image {
    aspect-ratio: auto;
    min-height: 400px;
  }
}

.KeysHome .alt-services h3 {
  font-size: clamp(1.375rem, 1.1rem + 1.2vw, 1.75rem);
}

.KeysHome .alt-services h3::after {
  left: auto;
  inset-inline-start: 0;
}

.KeysHome .alt-services .icon-box {
  margin-top: clamp(24px, 4vw, 50px);
}

.KeysHome .alt-services .icon-box h4 {
  font-size: 1.0625rem;
}

.KeysHome .alt-services .icon-box ul {
  margin-bottom: 0.5rem;
  padding-inline-start: 1.25rem;
}

.KeysHome .alt-services .img-fluid img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.KeysHome .alt-services .btn.rounded-pill {
  align-self: flex-start;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  margin-top: 32px;
  padding-inline: 28px;
}

/* ------------------------------------------------------------------- Forms */
.KeysHome .get-started .content h3 {
  font-size: clamp(1.5rem, 1.1rem + 1.8vw, 2.25rem);
}

.KeysHome .get-started .content h3::after {
  left: auto;
  inset-inline-start: 0;
}

.KeysHome .get-started .content p,
.KeysHome .get-started .content li {
  font-size: 1rem;
}

.KeysHome .get-started .php-email-form {
  padding: clamp(20px, 4vw, 30px);
}

.KeysHome .quote-form__label {
  display: block;
  margin-bottom: 6px;
  color: var(--heading-color);
  font-weight: 600;
  font-size: 0.9375rem;
}

.KeysHome .quote-form__required {
  color: #b42318;
}

/* 16px text stops iOS from zooming into the field. */
.KeysHome .get-started .php-email-form .form-control {
  width: 100%;
  min-height: 48px;
  font-size: 16px;
  padding: 10px 14px;
  border-radius: 4px;
  color: var(--default-color);
  background-color: #ffffff;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 65%);
}

.KeysHome .get-started .php-email-form .form-control:focus {
  border-color: var(--accent-color);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-color), transparent 65%);
}

.KeysHome .get-started .php-email-form .form-control.is-invalid {
  border-color: #b42318;
  background-image: none;
  padding-inline-end: 14px;
}

.KeysHome .get-started .php-email-form .form-control.is-invalid:focus {
  box-shadow: 0 0 0 3px rgba(180, 35, 24, 0.25);
}

/* The template hides these until its own JS shows them; React renders them only when needed. */
.KeysHome .php-email-form .loading,
.KeysHome .php-email-form .error-message,
.KeysHome .php-email-form .sent-message {
  display: block;
  margin-bottom: 16px;
  text-align: start;
}

.KeysHome .php-email-form .error-message {
  background: #b42318;
}

.KeysHome .get-started .php-email-form button[type="submit"] {
  width: 100%;
  min-height: 48px;
  padding: 10px 30px;
  color: var(--accent-ink);
  font-weight: 600;
  font-size: 1rem;
}

.KeysHome .get-started .php-email-form button[type="submit"]:disabled {
  opacity: 0.65;
  cursor: progress;
}

@media (min-width: 576px) {
  .KeysHome .get-started .php-email-form button[type="submit"] {
    width: auto;
    min-width: 200px;
  }
}

/* Opening hours: stacked on phones, one row of five on desktop. */
.KeysHome .opening-hours {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin: 0;
}

.KeysHome .opening-hours__row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 85%);
  border-radius: 6px;
  background: var(--surface-color);
}

.KeysHome .opening-hours dt {
  font-weight: 600;
}

.KeysHome .opening-hours dd {
  margin: 0;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .KeysHome .opening-hours {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }

  .KeysHome .opening-hours__row {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 4px;
  }
}

/* ---------------------------------------------------------------- Projects */
.KeysHome .projects .portfolio-filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px 8px;
}

.KeysHome .projects .portfolio-filters li {
  margin: 0;
}

.KeysHome .projects .portfolio-filters button {
  min-height: 44px;
  padding: 8px 12px;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.KeysHome .projects .portfolio-filters li.filter-active button {
  color: var(--accent-text);
  box-shadow: inset 0 -2px 0 var(--accent-color);
}

.KeysHome .projects .portfolio-content img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}

.KeysHome .projects .portfolio-content .portfolio-info .preview-link,
.KeysHome .projects .portfolio-content .portfolio-info .details-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  top: calc(50% - 22px);
  line-height: 1;
  font-size: 26px;
}

.KeysHome .projects .portfolio-content .portfolio-info .preview-link {
  left: calc(50% - 48px);
}

.KeysHome .projects .portfolio-content .portfolio-info .details-link {
  left: calc(50% + 4px);
}

.KeysHome .projects .portfolio-content:focus-within .portfolio-info {
  opacity: 1;
}

/* Touch screens have no hover: keep the captions and actions visible. */
@media (hover: none) {
  .KeysHome .projects .portfolio-content .portfolio-info {
    opacity: 1;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.15));
  }

  .KeysHome .projects .portfolio-content:hover img {
    transform: none;
  }
}

/* ------------------------------------------------------------ Legal pages */
.KeysHome .legal-text {
  max-width: 72ch;
  margin-inline: auto;
  text-align: start;
}

.KeysHome .legal-text p,
.KeysHome .legal-text li {
  font-weight: 600;
  overflow-wrap: anywhere;
}

/* ------------------------------------------------------------------ Footer */
.KeysHome .footer .footer-links__title {
  position: relative;
  padding-bottom: 12px;
  font-size: 1rem;
  font-weight: 700;
}

.KeysHome .footer .footer-links ul li {
  padding: 0;
}

.KeysHome .footer .footer-links ul a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  line-height: 1.3;
}

.KeysHome .footer .social-links {
  flex-wrap: wrap;
  gap: 8px;
}

.KeysHome .footer .social-links a {
  width: 44px;
  height: 44px;
  margin: 0;
}

.KeysHome .footer .copyright p {
  overflow-wrap: anywhere;
}

@media (prefers-reduced-motion: reduce) {
  .KeysHome .projects .portfolio-content:hover img {
    transform: none;
  }
}

/* ------------------------------------------------------ Home intro block */
.KeysHome .start-first-text {
  text-align: center;
}

.KeysHome .start-first-text h2 {
  font-size: clamp(1.375rem, 1.1rem + 1.4vw, 2rem);
  margin-bottom: 20px;
}

.KeysHome .start-first-text ul {
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
}

.KeysHome .start-first-text li + li {
  margin-top: 6px;
}

/* ---------------------------------------------------------- Contact block */
.KeysHome .contact-details {
  list-style: none;
  margin: 0 0 32px;
  padding: 0;
  display: grid;
  gap: 4px;
}

.KeysHome .contact-details a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--accent-text);
  font-weight: 600;
}

.KeysHome .map-consent {
  padding: 24px 0;
}

.KeysHome .map-consent .ant-result-title {
  font-size: clamp(1.125rem, 1rem + 0.8vw, 1.5rem);
}

.KeysHome .map-consent .ant-btn,
.KeysHome .contact-form .ant-btn {
  min-height: 48px;
  min-width: 160px;
  max-width: 100%;
  padding-inline: 28px;
  white-space: normal;
}

.KeysHome .contact-form .ant-input {
  min-height: 48px;
  font-size: 16px;
}

.KeysHome .contact-form .ant-checkbox-wrapper {
  align-items: flex-start;
  min-height: 44px;
}

.KeysHome .contact-form__submit {
  text-align: center;
}

.KeysHome .contact-form__status {
  margin-bottom: 16px;
}

@media (max-width: 575.98px) {
  .KeysHome .map-consent .ant-btn,
  .KeysHome .contact-form .ant-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Key-Company/KeysHome.css"],"names":[],"mappings":"AAAA;;;;;;+EAM+E;;AAE/E;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8EAA8E;EAC9E,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,yCAAyC;AACzC;;;EAGE,oDAAoD;AACtD;;AAEA,2EAA2E;AAC3E;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA,8EAA8E;AAC9E;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC;;mBAEiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,wDAAwD;AACxD;EACE;IACE,aAAa;IACb,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,4BAA4B;IAC5B,wEAAwE;IACxE,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;EACf;;EAEA;;IAEE,sBAAsB;IACtB,UAAU;IACV,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8EAA8E;AAC9E;;EAEE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,8EAA8E;AAC9E;EACE,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,2EAA2E;AAC7E;;AAEA;EACE,iCAAiC;EACjC,8EAA8E;AAChF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,+FAA+F;AAC/F;;;EAGE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2EAA2E;EAC3E,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,wEAAwE;AACxE;EACE;IACE,UAAU;IACV,4EAA4E;EAC9E;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6EAA6E;AAC7E;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* ==========================================================================\n   Key service site (Schluesseldienst): mobile-first layer.\n   Loaded by components/Header.jsx right after assets/css/main.css (the\n   BootstrapMade template) and overrides it. Phones are the base case; wider\n   screens add columns. Every selector is scoped to .KeysHome so\n   nothing leaks into the panel app. Logical properties keep RTL working.\n   ========================================================================== */\n\n.KeysHome {\n  --site-header-h: 64px;\n  --site-gutter: 16px;\n  /* Accent text on light backgrounds: #feb900 is too light for text on white. */\n  --accent-text: #8a6300;\n  --accent-ink: #1f2328;\n  font-size: 1rem;\n  line-height: 1.6;\n  overflow-wrap: break-word;\n  overflow-x: clip;\n}\n\n@media (min-width: 1200px) {\n  .KeysHome {\n    --site-header-h: 80px;\n  }\n}\n\n.KeysHome img {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Anchors land below the fixed header. */\n.KeysHome [id],\n.KeysHome section,\n.KeysHome .section {\n  scroll-margin-top: calc(var(--site-header-h) + 12px);\n}\n\n/* Keyboard focus in the site's accent (the panel's global ring is teal). */\n.KeysHome :focus-visible {\n  outline-color: var(--accent-color) !important;\n  box-shadow: 0 0 0 4px rgba(31, 35, 40, 0.55);\n}\n\n/* ------------------------------------------------------------------ Header */\n.KeysHome .site-header {\n  --nav-text: #ffffff;\n  z-index: 997;\n  color: var(--nav-text);\n  background-color: rgba(0, 0, 0, 0.35);\n  transition:\n    background-color 0.3s,\n    box-shadow 0.3s;\n}\n\n.KeysHome .site-header.sticked,\n.KeysHome .site-header.is-open {\n  --nav-text: #1f2328;\n  background-color: #ffffff;\n  box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);\n}\n\n.KeysHome .site-header__bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: var(--site-header-h);\n  padding-inline: var(--site-gutter);\n}\n\n.KeysHome .site-header__logo {\n  display: inline-flex;\n  align-items: baseline;\n  min-width: 0;\n  min-height: 44px;\n  align-self: center;\n  padding-block: 8px;\n  margin-inline-end: auto;\n  color: var(--nav-text);\n  font-family: var(--heading-font);\n  font-weight: 700;\n  font-size: clamp(1.25rem, 1rem + 1.2vw, 1.75rem);\n  line-height: 1.2;\n}\n\n.KeysHome .site-header__logo .sitename {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.KeysHome .site-header__dot {\n  color: var(--accent-color);\n}\n\n.KeysHome .site-header__toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--nav-text);\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.KeysHome .site-nav ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.KeysHome .site-nav__link,\n.KeysHome .site-nav__sublink {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 48px;\n  padding: 10px 12px;\n  border: 0;\n  background: none;\n  color: #1f2328;\n  font-family: var(--nav-font);\n  font-size: 1.0625rem;\n  font-weight: 500;\n  text-align: start;\n  cursor: pointer;\n}\n\n.KeysHome .site-nav__link.active,\n.KeysHome .site-nav__sublink.active {\n  color: var(--accent-text);\n  box-shadow: inset 3px 0 0 var(--accent-color);\n}\n\n[dir=\"rtl\"] .KeysHome .site-nav__link.active,\n[dir=\"rtl\"] .KeysHome .site-nav__sublink.active {\n  box-shadow: inset -3px 0 0 var(--accent-color);\n}\n\n.KeysHome .site-nav__chevron {\n  flex: none;\n  font-size: 0.75em;\n  transition: transform 0.2s;\n}\n\n.KeysHome .site-nav__item--has-sub.is-open .site-nav__chevron {\n  transform: rotate(180deg);\n}\n\n.KeysHome .site-nav__sub {\n  display: none;\n}\n\n.KeysHome .site-nav__item--has-sub.is-open > .site-nav__sub {\n  display: block;\n}\n\n.KeysHome .site-nav__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.KeysHome .site-header__login {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 8px 24px;\n  border-radius: 8px;\n  background: var(--accent-color);\n  color: var(--accent-ink);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.KeysHome .site-header__login:hover {\n  background: #ffc933;\n  color: var(--accent-ink);\n}\n\n/* Phones and tablets: full-width panel below the bar. */\n@media (max-width: 1199.98px) {\n  .KeysHome .site-nav {\n    display: none;\n    position: fixed;\n    inset: var(--site-header-h) 0 0 0;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    padding: 8px var(--site-gutter) calc(24px + env(safe-area-inset-bottom));\n    background: #ffffff;\n    border-top: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  .KeysHome .site-header.is-open .site-nav {\n    display: block;\n  }\n\n  .KeysHome .site-nav__list > li {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  .KeysHome .site-nav__sub {\n    padding-block-end: 8px;\n    padding-inline-start: 12px;\n  }\n\n  .KeysHome .site-nav__sublink {\n    font-size: 1rem;\n    font-weight: 400;\n    min-height: 44px;\n  }\n\n  .KeysHome .site-nav__actions {\n    padding-block-start: 20px;\n  }\n\n  .KeysHome .site-header__login {\n    flex: 1 1 160px;\n  }\n}\n\n/* Desktop: inline menu, hover/focus dropdown. */\n@media (min-width: 1200px) {\n  .KeysHome .site-header__toggle {\n    display: none;\n  }\n\n  .KeysHome .site-nav {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .KeysHome .site-nav__list {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .KeysHome .site-nav__list > li {\n    position: relative;\n  }\n\n  .KeysHome .site-nav__link {\n    width: auto;\n    min-height: 44px;\n    padding: 8px 12px;\n    color: var(--nav-text);\n    font-size: 14px;\n    text-transform: uppercase;\n    white-space: nowrap;\n    opacity: 0.85;\n  }\n\n  .KeysHome .site-nav__link:hover,\n  .KeysHome .site-nav__link.active {\n    color: var(--nav-text);\n    opacity: 1;\n    box-shadow: inset 0 -2px 0 var(--accent-color);\n  }\n\n  [dir=\"rtl\"] .KeysHome .site-nav__link.active {\n    box-shadow: inset 0 -2px 0 var(--accent-color);\n  }\n\n  .KeysHome .site-nav__sub {\n    position: absolute;\n    inset-block-start: 100%;\n    inset-inline-start: 0;\n    z-index: 99;\n    min-width: 280px;\n    padding: 8px 0;\n    border-radius: 6px;\n    background: #ffffff;\n    box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);\n  }\n\n  .KeysHome .site-nav__item--has-sub:hover > .site-nav__sub,\n  .KeysHome .site-nav__item--has-sub:focus-within > .site-nav__sub {\n    display: block;\n  }\n\n  .KeysHome .site-nav__sublink {\n    min-height: 44px;\n    padding: 8px 20px;\n    font-size: 15px;\n    font-weight: 400;\n  }\n\n  .KeysHome .site-nav__sublink:hover {\n    color: var(--accent-text);\n  }\n}\n\n/* -------------------------------------------------------------------- Hero */\n.KeysHome .hero {\n  isolation: isolate;\n  min-height: 100vh;\n  min-height: 100svh;\n  background-color: #1f2328;\n}\n\n.KeysHome .hero--compact {\n  min-height: clamp(320px, 55svh, 520px);\n}\n\n.KeysHome .hero__media {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  object-fit: cover;\n}\n\n.KeysHome .hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.KeysHome .hero .info {\n  width: 100%;\n  padding: calc(var(--site-header-h) + 32px) 0 48px;\n}\n\n.KeysHome .hero .info .hero__title {\n  position: relative;\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  color: #ffffff !important;\n  font-size: clamp(1.75rem, 1.1rem + 3.4vw, 3.5rem);\n  font-weight: 700;\n  line-height: 1.15;\n  overflow-wrap: anywhere;\n  hyphens: auto;\n}\n\n.KeysHome .hero--compact .info .hero__title {\n  font-size: clamp(1.5rem, 1.1rem + 2.2vw, 2.75rem);\n}\n\n.KeysHome .hero .info .hero__title::after {\n  content: \"\";\n  position: absolute;\n  inset-inline: 0;\n  bottom: 0;\n  width: 80px;\n  height: 4px;\n  margin: auto;\n  background: var(--accent-color);\n}\n\n.KeysHome .hero .info p {\n  color: #e6e3e3;\n  font-size: clamp(1rem, 0.95rem + 0.4vw, 1.125rem);\n}\n\n.KeysHome .hero .info .btn-get-started {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 10px 32px;\n  margin: 8px 0 0;\n  color: #ffffff;\n}\n\n.KeysHome .hero .info .btn-get-started:hover {\n  color: var(--accent-ink);\n}\n\n/* ---------------------------------------------------------------- Sections */\n.KeysHome section,\n.KeysHome .section {\n  padding-block: clamp(40px, 6vw, 60px);\n}\n\n.KeysHome .section-title {\n  padding-bottom: clamp(32px, 5vw, 60px);\n}\n\n.KeysHome .section-title h2 {\n  font-size: clamp(1.5rem, 1.15rem + 1.6vw, 2rem);\n}\n\n.KeysHome .section-title h2::before,\n.KeysHome .section-title h2::after {\n  width: clamp(20px, 6vw, 50px);\n}\n\n.KeysHome .section-title h2::before {\n  margin: 0;\n  margin-inline-end: 12px;\n  margin-block-end: 10px;\n}\n\n.KeysHome .section-title h2::after {\n  margin: 0;\n  margin-inline-start: 12px;\n  margin-block-end: 10px;\n}\n\n/* Services cards */\n.KeysHome .services .service-item {\n  padding: clamp(24px, 4vw, 40px);\n}\n\n.KeysHome .services .service-item .icon {\n  width: 72px;\n  height: 72px;\n  margin-bottom: 24px;\n}\n\n.KeysHome .services .service-item .icon svg {\n  font-size: 40px;\n}\n\n.KeysHome .services .service-item h3 {\n  font-size: clamp(1.125rem, 1rem + 0.6vw, 1.375rem);\n}\n\n.KeysHome .services .service-item p {\n  font-size: 0.9375rem;\n  line-height: 1.6;\n}\n\n.KeysHome .services .service-item .readmore {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 44px;\n  margin-top: 8px;\n}\n\n/* Alt services (home + Leistungen pages) */\n.KeysHome .alt-services .features-image {\n  min-height: 0;\n  aspect-ratio: 4 / 3;\n}\n\n@media (min-width: 992px) {\n  .KeysHome .alt-services .features-image {\n    aspect-ratio: auto;\n    min-height: 400px;\n  }\n}\n\n.KeysHome .alt-services h3 {\n  font-size: clamp(1.375rem, 1.1rem + 1.2vw, 1.75rem);\n}\n\n.KeysHome .alt-services h3::after {\n  left: auto;\n  inset-inline-start: 0;\n}\n\n.KeysHome .alt-services .icon-box {\n  margin-top: clamp(24px, 4vw, 50px);\n}\n\n.KeysHome .alt-services .icon-box h4 {\n  font-size: 1.0625rem;\n}\n\n.KeysHome .alt-services .icon-box ul {\n  margin-bottom: 0.5rem;\n  padding-inline-start: 1.25rem;\n}\n\n.KeysHome .alt-services .img-fluid img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n.KeysHome .alt-services .btn.rounded-pill {\n  align-self: flex-start;\n  min-height: 48px;\n  display: inline-flex;\n  align-items: center;\n  margin-top: 32px;\n  padding-inline: 28px;\n}\n\n/* ------------------------------------------------------------------- Forms */\n.KeysHome .get-started .content h3 {\n  font-size: clamp(1.5rem, 1.1rem + 1.8vw, 2.25rem);\n}\n\n.KeysHome .get-started .content h3::after {\n  left: auto;\n  inset-inline-start: 0;\n}\n\n.KeysHome .get-started .content p,\n.KeysHome .get-started .content li {\n  font-size: 1rem;\n}\n\n.KeysHome .get-started .php-email-form {\n  padding: clamp(20px, 4vw, 30px);\n}\n\n.KeysHome .quote-form__label {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--heading-color);\n  font-weight: 600;\n  font-size: 0.9375rem;\n}\n\n.KeysHome .quote-form__required {\n  color: #b42318;\n}\n\n/* 16px text stops iOS from zooming into the field. */\n.KeysHome .get-started .php-email-form .form-control {\n  width: 100%;\n  min-height: 48px;\n  font-size: 16px;\n  padding: 10px 14px;\n  border-radius: 4px;\n  color: var(--default-color);\n  background-color: #ffffff;\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 65%);\n}\n\n.KeysHome .get-started .php-email-form .form-control:focus {\n  border-color: var(--accent-color);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-color), transparent 65%);\n}\n\n.KeysHome .get-started .php-email-form .form-control.is-invalid {\n  border-color: #b42318;\n  background-image: none;\n  padding-inline-end: 14px;\n}\n\n.KeysHome .get-started .php-email-form .form-control.is-invalid:focus {\n  box-shadow: 0 0 0 3px rgba(180, 35, 24, 0.25);\n}\n\n/* The template hides these until its own JS shows them; React renders them only when needed. */\n.KeysHome .php-email-form .loading,\n.KeysHome .php-email-form .error-message,\n.KeysHome .php-email-form .sent-message {\n  display: block;\n  margin-bottom: 16px;\n  text-align: start;\n}\n\n.KeysHome .php-email-form .error-message {\n  background: #b42318;\n}\n\n.KeysHome .get-started .php-email-form button[type=\"submit\"] {\n  width: 100%;\n  min-height: 48px;\n  padding: 10px 30px;\n  color: var(--accent-ink);\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.KeysHome .get-started .php-email-form button[type=\"submit\"]:disabled {\n  opacity: 0.65;\n  cursor: progress;\n}\n\n@media (min-width: 576px) {\n  .KeysHome .get-started .php-email-form button[type=\"submit\"] {\n    width: auto;\n    min-width: 200px;\n  }\n}\n\n/* Opening hours: stacked on phones, one row of five on desktop. */\n.KeysHome .opening-hours {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  margin: 0;\n}\n\n.KeysHome .opening-hours__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 16px;\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 85%);\n  border-radius: 6px;\n  background: var(--surface-color);\n}\n\n.KeysHome .opening-hours dt {\n  font-weight: 600;\n}\n\n.KeysHome .opening-hours dd {\n  margin: 0;\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n  .KeysHome .opening-hours {\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  }\n\n  .KeysHome .opening-hours__row {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 4px;\n  }\n}\n\n/* ---------------------------------------------------------------- Projects */\n.KeysHome .projects .portfolio-filters {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 4px 8px;\n}\n\n.KeysHome .projects .portfolio-filters li {\n  margin: 0;\n}\n\n.KeysHome .projects .portfolio-filters button {\n  min-height: 44px;\n  padding: 8px 12px;\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.KeysHome .projects .portfolio-filters li.filter-active button {\n  color: var(--accent-text);\n  box-shadow: inset 0 -2px 0 var(--accent-color);\n}\n\n.KeysHome .projects .portfolio-content img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info .preview-link,\n.KeysHome .projects .portfolio-content .portfolio-info .details-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  top: calc(50% - 22px);\n  line-height: 1;\n  font-size: 26px;\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info .preview-link {\n  left: calc(50% - 48px);\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info .details-link {\n  left: calc(50% + 4px);\n}\n\n.KeysHome .projects .portfolio-content:focus-within .portfolio-info {\n  opacity: 1;\n}\n\n/* Touch screens have no hover: keep the captions and actions visible. */\n@media (hover: none) {\n  .KeysHome .projects .portfolio-content .portfolio-info {\n    opacity: 1;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.15));\n  }\n\n  .KeysHome .projects .portfolio-content:hover img {\n    transform: none;\n  }\n}\n\n/* ------------------------------------------------------------ Legal pages */\n.KeysHome .legal-text {\n  max-width: 72ch;\n  margin-inline: auto;\n  text-align: start;\n}\n\n.KeysHome .legal-text p,\n.KeysHome .legal-text li {\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n/* ------------------------------------------------------------------ Footer */\n.KeysHome .footer .footer-links__title {\n  position: relative;\n  padding-bottom: 12px;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.KeysHome .footer .footer-links ul li {\n  padding: 0;\n}\n\n.KeysHome .footer .footer-links ul a {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  line-height: 1.3;\n}\n\n.KeysHome .footer .social-links {\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.KeysHome .footer .social-links a {\n  width: 44px;\n  height: 44px;\n  margin: 0;\n}\n\n.KeysHome .footer .copyright p {\n  overflow-wrap: anywhere;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .KeysHome .projects .portfolio-content:hover img {\n    transform: none;\n  }\n}\n\n/* ------------------------------------------------------ Home intro block */\n.KeysHome .start-first-text {\n  text-align: center;\n}\n\n.KeysHome .start-first-text h2 {\n  font-size: clamp(1.375rem, 1.1rem + 1.4vw, 2rem);\n  margin-bottom: 20px;\n}\n\n.KeysHome .start-first-text ul {\n  list-style: none;\n  margin: 0 0 16px;\n  padding: 0;\n}\n\n.KeysHome .start-first-text li + li {\n  margin-top: 6px;\n}\n\n/* ---------------------------------------------------------- Contact block */\n.KeysHome .contact-details {\n  list-style: none;\n  margin: 0 0 32px;\n  padding: 0;\n  display: grid;\n  gap: 4px;\n}\n\n.KeysHome .contact-details a {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  color: var(--accent-text);\n  font-weight: 600;\n}\n\n.KeysHome .map-consent {\n  padding: 24px 0;\n}\n\n.KeysHome .map-consent .ant-result-title {\n  font-size: clamp(1.125rem, 1rem + 0.8vw, 1.5rem);\n}\n\n.KeysHome .map-consent .ant-btn,\n.KeysHome .contact-form .ant-btn {\n  min-height: 48px;\n  min-width: 160px;\n  max-width: 100%;\n  padding-inline: 28px;\n  white-space: normal;\n}\n\n.KeysHome .contact-form .ant-input {\n  min-height: 48px;\n  font-size: 16px;\n}\n\n.KeysHome .contact-form .ant-checkbox-wrapper {\n  align-items: flex-start;\n  min-height: 44px;\n}\n\n.KeysHome .contact-form__submit {\n  text-align: center;\n}\n\n.KeysHome .contact-form__status {\n  margin-bottom: 16px;\n}\n\n@media (max-width: 575.98px) {\n  .KeysHome .map-consent .ant-btn,\n  .KeysHome .contact-form .ant-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
